import React, { Component } from 'react';
import { DRAGGABLE_WINDOWS } from '../../constants'
import { supervisorChatExpanded, noAvailableRecordExpanded, noAvailableExpanded } from '../../js/ExpandedComponents'
import { SingletonSharedData } from '../../js/singletonSharedData';
import { connect } from 'react-redux';


class WorkBarExpanded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedComponent: null,
      barExpandedClass: "WBExpanded",
      arrayComponents: []
    }
    this.windows = {
      [DRAGGABLE_WINDOWS.SUPERVISOR_CHAT]: supervisorChatExpanded(null),
      [DRAGGABLE_WINDOWS.NO_AVAILABLE]: noAvailableExpanded(null),
      [DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]: noAvailableRecordExpanded(null),
    }
    this.sharedData = new SingletonSharedData();
  }

  componentWillReceiveProps(nextProps) {
    let arrayComponents = [];
    for (let comp in nextProps.windowsOpened) {
      if (this.windows[nextProps.windowsOpened[comp].idComponent]) {
        arrayComponents.push(nextProps.windowsOpened[comp]);
      }
    }

    if (arrayComponents.length > 0 ) {
      if(!nextProps.simultaneosRecs)
      {
        this.setState({ barExpandedClass: "WBExpanded isShowed" });
      }else
      {
        this.setState({ barExpandedClass: "WBExpanded simultaneosRecs"});
      }

      let found = arrayComponents.filter((element) => {
        return element.idComponent === this.sharedData.getWindowExpandedActive();
      })[0];
      if (typeof found === "undefined") {
        this.sharedData.setWindowExpandedActive(arrayComponents[0].idComponent);
      }
      this.setState({ arrayComponents: arrayComponents });
    } else {
      this.sharedData.setWindowExpandedActive(DRAGGABLE_WINDOWS.NONE)
      this.setState({ barExpandedClass: "WBExpanded", arrayComponents: [] });
    }
  }
  render() {
    return (
      <div className={this.state.barExpandedClass}>
        {this.state.arrayComponents.map((item, i) => this.windows[item.idComponent].component)}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { 
    simultaneosRecs: state.preview.simultaneosRecs
  }
}

export default WorkBarExpanded = connect(
  mapStateToProps,
  null
)(WorkBarExpanded);


// WEBPACK FOOTER //
// ./src/components/workSpace/workBarExpanded.jsx